import { render, staticRenderFns } from "./ExpandableSidebar.vue?vue&type=template&id=3c2d240f&scoped=true&"
import script from "./ExpandableSidebar.vue?vue&type=script&lang=ts&"
export * from "./ExpandableSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableSidebar.vue?vue&type=style&index=0&id=3c2d240f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2d240f",
  null
  
)

export default component.exports